import { cn } from '../../lib/cn';
import type { CampaignRow } from '../../revenueintel/framework';

type Props = { campaigns?: CampaignRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'active': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    case 'learning': return 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function CampaignManagementPanel({ campaigns = [] }: Props) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-xs uppercase text-slate-500 dark:border-slate-700">
            <th className="pb-2 pr-4 font-medium">Campaign</th>
            <th className="pb-2 pr-4 font-medium">Type</th>
            <th className="pb-2 pr-4 font-medium">Budget</th>
            <th className="pb-2 pr-4 font-medium">ROAS</th>
            <th className="pb-2 font-medium">Status</th>
          </tr>
        </thead>
        <tbody>
          {campaigns.map((c) => (
            <tr key={c.name} className="border-b border-slate-100 dark:border-slate-800">
              <td className="py-2.5 pr-4 font-medium text-slate-900 dark:text-slate-100">{c.name}</td>
              <td className="py-2.5 pr-4 text-slate-600 dark:text-slate-400">{c.type}</td>
              <td className="py-2.5 pr-4 text-slate-600 dark:text-slate-400">{c.budget}</td>
              <td className="py-2.5 pr-4 font-semibold text-brand-600">{c.roas}</td>
              <td className="py-2.5">
                <span className={cn('rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(c.status))}>
                  {c.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
